import { ActionsSliceData } from '@adapters/prismic/types/slices';
import Button from '@components/ui/Button';
import styles from './Actions.module.scss';

const Actions = ({
  id,
  items,
}: {
  id: string | undefined;
  items: ActionsSliceData[];
}) => {
  const getVariant = (importance = '') => {
    switch (importance) {
      case 'primary':
        return 'primary';
      case 'normal':
        return 'secondary';
      default:
        return 'unstyled';
    }
  };

  return (
    <div id={id} className={styles.actionsContainer}>
      {items.map(({ label, link, importance }) => (
        <Button
          key={`action-${label}`}
          className={styles.actionButton}
          size="large"
          label={label}
          variant={getVariant(importance)}
          href={link}
        />
      ))}
    </div>
  );
};

export default Actions;
